import { Wrapper, ShortcutImage, ShortcutName, ShortcutNameText } from './Styled'
import { useShortcutBoxHandler } from 'hooks/useShortcutBoxHandler'

interface Props {
  info: any
  autoWidth?: boolean
  avatarWidth?: number | string
  avatarHeight?: number | string
}

/** 金剛區文字顯示寬度預算：半形=1、全形=2，預算 10（= 5 個中文字寬 = 10 個英數字寬）。 */
const HALF_WIDTH = 1
const FULL_WIDTH = 2
const MAX_DISPLAY_WIDTH = 10

/**
 * 依顯示寬度截斷金剛區文字。
 * ASCII 可見字元（0x20–0x7E：英數/半形標點/空格）計為半形寬度 1；其餘（中文/全形/emoji 等）計為全形寬度 2。
 * 累計寬度加入某字後超過預算即停止（不塞入該字）。以 code point 迭代（for...of）避免拆散 emoji 的 UTF-16 代理對。
 * 已知邊界：(1) 非 ASCII 半形字（如 é/ü）保守計為全形——只會少顯示、不會破版；
 *          (2) ZWJ 組合 emoji（👨‍👩‍👦）可能被切開——最壞為顯示不完整，佈局仍由 Styled 的 overflow 邊界保證不破版。
 */
const truncateByDisplayWidth = (text: unknown): string => {
  const str = text == null ? '' : String(text)
  let width = 0
  let result = ''
  for (const ch of str) {
    const code = ch.codePointAt(0) ?? 0
    const w = code >= 0x20 && code <= 0x7e ? HALF_WIDTH : FULL_WIDTH
    if (width + w > MAX_DISPLAY_WIDTH) break
    width += w
    result += ch
  }
  return result
}

/**
 * 元件 - 金剛區選項(快捷鍵)
 */
export default function Shortcut({ info, autoWidth, avatarWidth, avatarHeight }: Props) {
  const openShortcutBox = useShortcutBoxHandler()
  const chooseRedirectFunction = () => {
    openShortcutBox(info)
  }

  return (
    <Wrapper autoWidth={autoWidth} onClick={chooseRedirectFunction}>
      <ShortcutImage src={info?.icon_path} width={avatarWidth} height={avatarHeight} allowUnload />

      <ShortcutName>
        <ShortcutNameText>{truncateByDisplayWidth(info.name)}</ShortcutNameText>
      </ShortcutName>
    </Wrapper>
  )
}
